<template>
    <div>
        <rkm-form
            :show-legend="!!model.logradouro_id"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.paises"
                        :validations="validations.pais_id"
                        disabled
                        label="País"
                        show-default-option
                        v-model="model.pais_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        readonly
                        label="CEP"
                        v-model="model.logradouro_cep"
                        :validations="validations.logradouro_cep"
                    >
                        <rkm-input-group-append
                            class="ml-2"
                            slot="append"
                        >
                            <rkm-button
                                v-if="authorize('cadastro-logradouro-store')"
                                :disabled="model.pais_id !== enums.Pais.BRASIL || disabled"
                                @click="$refs.ModalLogradouroForm.open()"
                                color="primary"
                                title="Cadastrar logradouro"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>

                            <rkm-button
                                :disabled="model.pais_id !== enums.Pais.BRASIL || disabled"
                                @click="$refs.ModalLogradouroList.open()"
                                color="info"
                                title="Listar logradouros"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="search" />
                            </rkm-button>

                            <rkm-button
                                :disabled="model.pais_id !== enums.Pais.BRASIL || disabled"
                                @click="model.logradouro_id = null"
                                color="danger"
                                title="Limpar logradouro"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="times" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.estados"
                        disabled
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.estado_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        disabled
                        label="Município de residência"
                        v-model="model.municipio_nome"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Bairro"
                        v-model="model.bairro_nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.logradouro_tipos"
                        disabled
                        label="Tipo de logradouro"
                        show-default-option
                        v-model="model.logradouro_tipo_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Logradouro"
                        v-model="model.logradouro_nome"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :disabled="!model.logradouro_id || model.sem_numero || disabled"
                        :validations="validations.numero"
                        label="Número"
                        number
                        v-model="model.numero"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    :disabled="disabled"
                                    v-model="model.sem_numero"
                                >
                                    Sem número
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :disabled="!model.logradouro_id || disabled"
                        :fields="fields.loteamento"
                        :repository="repositories.cadastro.loteamento"
                        :selected-text="model.loteamento_nome"
                        label="Loteamento"
                        v-model="model.loteamento_id"
                    >
                        <rkm-input-group-append
                            v-if="authorize('cadastro-loteamento-store')"
                            slot="append"
                        >
                            <rkm-button
                                :disabled="!model.logradouro_id || disabled"
                                @click="$refs.ModalLoteamentoForm.open()"
                                color="primary"
                                title="Cadastrar loteamento"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :disabled="!model.logradouro_id || disabled"
                        :validations="validations.complemento"
                        label="Complemento"
                        uppercase
                        v-model="model.complemento"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :disabled="!model.logradouro_id || disabled"
                        :validations="validations.ponto_referencia"
                        label="Ponto de referência"
                        uppercase
                        v-model="model.ponto_referencia"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :disabled="!model.logradouro_id"
                        :options="form.zonas"
                        :validations="validations.zona_id"
                        label="Zona"
                        show-default-option
                        text-field="descricao"
                        v-model="model.zona_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :disabled="!model.logradouro_id"
                        :options="form.tipos_moradia"
                        :validations="validations.tipo_moradia_id"
                        label="Tipo de moradia"
                        show-default-option
                        text-field="descricao"
                        v-model="model.tipo_moradia_id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalLogradouroForm
            :classificacao_id="model.classificacao_id"
            @save="handleLogradouroSave"
            ref="ModalLogradouroForm"
        />

        <ModalLogradouroList
            :classificacao_id="model.classificacao_id"
            @select="handleLogradouroSelect"
            ref="ModalLogradouroList"
        />

        <ModalLoteamentoForm
            @save="handleLoteamentoSave"
            ref="ModalLoteamentoForm"
        />
    </div>
</template>

<script>
// Components.
import ModalLogradouroForm from '@/components/cadastro/logradouro/components/form/Modal'
import ModalLogradouroList from '@/components/cadastro/logradouro/components/list/Modal'
import ModalLoteamentoForm from '@/components/cadastro/loteamento/Modal'

// Enums.
import {Pais} from '@/enums'

// Mixins.
import {authorization} from '@/mixins'

// Others.
import moment from 'moment'

// Utils.
import format from '@/utils/format'

export default {
    components: {
        ModalLogradouroForm,
        ModalLogradouroList,
        ModalLoteamentoForm,
    },
    computed: {
        fields() {
            return {
                loteamento: [
                    {key: 'nome', name: 'cadastro_loteamento.nome'},
                ],
            }
        },
        validations() {
            return {
                pais_id: {required: true},
                estado_id: {required: true},
                municipio_id: {required: true},
                bairro_id: {required: true},
                logradouro_cep: {required: true},
                logradouro_tipo_id: {required: true},
                logradouro_id: {required: true},
                zona_id: {required: true},
                tipo_moradia_id: {required: true},
                numero: {
                    required: true,
                    min_value: 1,
                    max_value: 999999,
                },
                complemento: {
                    min: 3,
                    max: 180,
                },
                ponto_referencia: {
                    min: 3,
                    max: 150,
                },
            }
        },
    },
    data: () => ({
        enums: {Pais},
        others: {moment},
        utils: {format},
    }),
    inject: ['repositories'],
    methods: {
        handleLogradouroSave(logradouro) {
            this.model.logradouro_id = logradouro.id

            this.$nextTick(() => {
                this.model.logradouro_tipo_id = logradouro.tipo_id
                this.model.estado_id = logradouro.bairro.municipio.estado_id
                this.model.logradouro_cep = this.utils.format.cep(logradouro.cep)
                this.model.municipio_nome = logradouro.bairro.municipio.nome
                this.model.bairro_nome = logradouro.bairro.nome
                this.model.logradouro_nome = logradouro.nome
            })
        },
        handleLogradouroSelect(logradouro) {
            this.model.logradouro_id = logradouro.logradouro_id

            this.$nextTick(() => {
                this.model.logradouro_tipo_id = logradouro.logradouro_tipo_id
                this.model.estado_id = logradouro.estado_id
                this.model.logradouro_cep = this.utils.format.cep(logradouro.logradouro_cep)
                this.model.municipio_nome = logradouro.municipio_nome
                this.model.bairro_nome = logradouro.bairro_nome
                this.model.logradouro_nome = logradouro.logradouro_nome
            })
        },
        handleLoteamentoSave(loteamento) {
            this.model.loteamento_id = loteamento.id
            this.model.loteamento_nome = loteamento.nome
        },
        validate() {
            return this.$refs.RkmForm.validate()
        },
    },
    mixins: [authorization],
    props: {
        additionals: {type: Object, required: true},
        disabled: {type: Boolean, default: false},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
    watch: {
        'model.pais_id'() {
            this.model.logradouro_id = null
        },
        'model.logradouro_id'() {
            this.model.estado_id = null
            this.model.logradouro_tipo_id = null
            this.model.loteamento_id = null
            this.model.zona_id = null
            this.model.logradouro_cep = null
            this.model.municipio_nome = null
            this.model.bairro_nome = null
            this.model.logradouro_nome = null
            this.model.numero = null
            this.model.sem_numero = false
            this.model.loteamento_nome = null
            this.model.complemento = null
            this.model.ponto_referencia = null
        },
        'model.sem_numero'(value) {
            if (value) {
                this.model.numero = null
            }
        },
    },
}
</script>